import React, { useState, useCallback, useRef } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import { useLocation } from "react-router-dom";
import style from './Identity.module.css';

import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import ToastPopup from '../../../../components/comm/ToastPopup';
import URL from '../../../../constants/url';
import { getDpNiceRequest } from '../../../../assets/js/comm';

const Identity = () => {
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const location = useLocation();
    // 콜백들은 sns 키로 넘긴다.
    const { accessToken, email, moveToMenu } = location.state || {};
    const provider = location.state?.provider ?? location.state?.sns;

    //console.log( " ===============> location.state ::  ", location.state );

    const stateIdRef = useRef(null);

    const saveStateOnServer = useCallback(async () => {
        if (provider && provider !== 'idpw' && provider !== 'phone') {
            try {
                // 서버가 읽는 키는 sns.
                const res = await axiosApi.post('/nice/auth/sns/token/save', { accessToken, sns: provider });
                if (res.data?.resultCode === CODE.RCV_SUCCESS) {
                    const stateId = res.data.result?.stateId;
                    stateIdRef.current = stateId;
                    return stateId;
                }
                throw new Error(res.data?.resultMessage || 'STATE_SAVE_FAILED');
            } catch (e) {
                console.error('state 저장 실패:', e);
                setToastMessage('본인확인 준비 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.');
                setToast(true);
                throw e;
            }
        }
        return '';
    }, [accessToken, provider]);

    /**
     * 오리지날 나이스 리퀘스트
     * @type {(function(*): Promise<void>)|*}
     */
    const requestNiceAuth = useCallback(async (type, svc) => {
        try {
            const stateId = await saveStateOnServer();

            // SNS 가입이면 provider 를 실어야 콜백에서 SNS 계정으로 이어진다.
            const providerType = provider || type || 'idpw';

            const query = new URLSearchParams({
                svcType: svc || 'M',
                r1: stateId || '',
                emailAdres: email || '',
                moveToMenu: moveToMenu || ''
            }).toString();

            const url = `/nice/auth/request/${providerType}?${query}`;
            const res = await axiosApi.post(url, {});

            console.log( " ===============> requestNiceAuth res ::  ", res );

            if (res.data?.resultCode !== CODE.RCV_SUCCESS) {
                setToastMessage(res.data?.resultMessage || '본인인증 요청에 실패했습니다.');
                setToast(true);
                return;
            }

            const authUrl = res.data?.result?.authUrl;
            if (!authUrl) {
                setToastMessage('인증 URL이 없습니다.');
                setToast(true);
                return;
            }

            window.location.assign(authUrl);
        } catch (e) {
            console.error('NICE 인증 요청 실패:', e);
            setToastMessage('본인인증 요청 중 오류가 발생했습니다.');
            setToast(true);
        }
    }, [saveStateOnServer, provider, email, moveToMenu]);


    /**
     * 디팜 인증서버 나이스 리퀘스트
     * @type {(function(*): Promise<void>)|*}
     */
    const requestDpNiceAuth = useCallback(async (type) => {
        try {
            const stateId = await saveStateOnServer();

            // 콜백은 이 둘로 SNS 여부를 판단한다. DP 인증서버가 돌려주는 provider 는 인증수단이다.
            if (provider) {
                sessionStorage.setItem('sns_token', stateId || '');
                sessionStorage.setItem('sns_email', email || '');
            } else {
                sessionStorage.removeItem('sns_token');
                sessionStorage.removeItem('sns_email');
            }

            // ⚠ 1번째 인자는 인증수단이다. SNS(kakao 등)를 넣으면 DP 인증서버가 401 을 준다.
            await getDpNiceRequest(type || 'PASSWORD', moveToMenu || '');

        } catch (e) {
            console.error('NICE 인증 요청 실패:', e);
            setToastMessage('본인인증 요청 중 오류가 발생했습니다.');
            setToast(true);
        }
    }, [saveStateOnServer, provider, email, moveToMenu]);

    return (
        <>
            <HeadSub title="본인 확인" />

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap' data-padding="30">
                    <strong className={style['title']}>본인확인 방법을 선택해 주세요</strong>

                    <div className={style['mid-box']}>
                        <button className={style['mobile']} onClick={() => requestDpNiceAuth('PASSWORD')}>
                            <p>
                                <span>휴대폰</span>
                                <span>본인인증</span>
                            </p>
                        </button>
                        {/* 실제 niceid 키 모델이 아이핀서비스가 없는것으로 최종확인되어 영구 숨김처리 함.. 이주철책임 통해 확인완료. 2026.09.15
                        <button className={style['i-pin']} onClick={() => requestNiceAuth('idpw', "I")}>
                            <p>
                                <span>아이핀</span>
                                <span>본인인증</span>
                            </p>
                        </button>
                        */}
                    </div>
                </div>
            </div>

            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}
        </>
    );
};

export default Identity;
